var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge"},[_c('vs-chip',{attrs:{"color":_vm.enabled ? 'success' : 'danger'}},[_c('feather-icon',{staticClass:"w-4 h-4",attrs:{"icon":_vm.enabled ? 'CheckIcon' : 'XIcon'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }